import ToggleFFXIV from '@/app/components/ToggleFFXIV'
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useTranslation } from '@/hooks/useTranslation';
import { CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import React from 'react'

const FlashSelector = () => {
    const { t } = useTranslation();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();

    const handleFlashModeToggle = (hasFlashMode: boolean) => {
        if (isGameMaster) {
            updateSettings({ hasFlashMode } as Partial<CustomModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    if (!('hasFlashMode' in settings)) {
        return null;
    }

    const customSettings = settings as CustomModeSettings;

    return (
        <ToggleFFXIV
            value={customSettings.hasFlashMode}
            onChange={handleFlashModeToggle}
            text={t('game.modes.custom.enableFlashMode')}
            shape="square"
        />
    )
}

export default FlashSelector